if (!window.mixMuseMobileTabsReady) {
    window.mixMuseMobileTabsReady = true;

    const activateMixMuseTab = (root, index, moveFocus = false) => {
      const buttons = Array.from(root.querySelectorAll('[data-mm-tab-button]'));
      const panels = Array.from(root.querySelectorAll('[data-mm-tab-panel]'));
      buttons.forEach((button) => {
        const selected = button.dataset.mmTabButton === String(index);
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) button.focus();
      });
      panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.mmTabPanel === String(index)));
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-mm-tab-button]');
      if (!button) return;
      const root = button.closest('[data-mm-tabs-root]');
      if (root) activateMixMuseTab(root, button.dataset.mmTabButton);
    });

    document.addEventListener('keydown', (event) => {
      const button = event.target.closest('[data-mm-tab-button]');
      if (!button || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      const root = button.closest('[data-mm-tabs-root]');
      if (!root) return;
      const buttons = Array.from(root.querySelectorAll('[data-mm-tab-button]'));
      const current = Number(button.dataset.mmTabButton);
      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % buttons.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      event.preventDefault();
      activateMixMuseTab(root, next, true);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-mm-tab-panel]');
      const root = panel && panel.closest('[data-mm-tabs-root]');
      if (root) activateMixMuseTab(root, panel.dataset.mmTabPanel);
    });
  }